/* TCGShield — image drag prevention (global)
 *
 * Loaded site-wide from snippets/scripts.liquid. Pairs with
 * tcgshield-image-protect.css, which sets `user-drag: none` on every
 * <img>. The CSS hint is honoured by Chromium/WebKit but ignored by
 * Firefox, so we additionally listen for the `dragstart` event in the
 * capture phase and call preventDefault() when the source is an <img>.
 * Capture phase + a global document-level listener catch every drag
 * regardless of where the image is mounted (cart drawer, modal, fresh-
 * AJAX'd content, etc.) without needing per-element wiring.
 *
 * Scope and trade-offs intentionally narrow:
 *   - Only `dragstart` is intercepted. Right-click menus,
 *     long-press save sheets, accessibility tools, screen readers,
 *     in-browser translators, and touch interactions are all left
 *     untouched.
 *   - Determined visitors can still grab images via DevTools, the
 *     network tab, view-source, or screenshot — this is friction,
 *     not protection. Watermarks + lower-resolution variants are the
 *     real defence; this script just kills the casual drag-to-tab
 *     and drag-to-desktop reflexes.
 */
(function () {
  'use strict';
  document.addEventListener(
    'dragstart',
    function (event) {
      var target = event.target;
      if (target && target.tagName === 'IMG') {
        event.preventDefault();
      }
    },
    true
  );
})();
